import { endOfDay, startOfDay, subDays } from "date-fns"

import { createBasicLocation, ILocation } from "src/router/routeTypes"

const Reports: ILocation<{
  showIncidentReportDialog?: boolean
} | void> = {
  location(
    { showIncidentReportDialog } = {
      showIncidentReportDialog: false,
    }
  ) {
    const searchParams = new URLSearchParams()

    if (showIncidentReportDialog) {
      searchParams.set("showIncidentReportDialog", "true")
    }

    const searchString = searchParams.toString()
    return {
      pathname: "/reports",
      search: searchString ? `?${searchString}` : undefined,
    }
  },
} as const

const MoldInsights = createBasicLocation(
  `${Reports.location().pathname}/mold-insights`
)
const NoiseInsights: ILocation<{
  startDate?: Date
  endDate?: Date
} | void> = {
  location(
    { startDate, endDate } = {
      startDate: startOfDay(subDays(new Date(), 30)),
      endDate: endOfDay(new Date()),
    }
  ) {
    const searchParams = new URLSearchParams()

    if (startDate) {
      searchParams.set("startDate", startDate.toISOString())
    }
    if (endDate) {
      searchParams.set("endDate", endDate.toISOString())
    }

    const searchString = searchParams.toString()
    return {
      pathname: `${Reports.location().pathname}/noise-insights`,
      search: searchString ? `?${searchString}` : undefined,
    }
  },
} as const

export const ReportRoutes = { Reports, MoldInsights, NoiseInsights }
